export default __webpack_public_path__ + "static/media/feature2-3.1cae7f64.png";